
<script setup>
import {onMounted, onUnmounted, ref} from "vue";
import axios from "axios";
import router from "@/assets/js/router";
import {ElNotification} from "element-plus";
import {debounce} from "lodash";
import {useSize} from "@/assets/js/size";
const {width} = useSize();
let toLogin = debounce(() => {
  ElNotification({
    title: '',
    message: '请重新登录',
    type: 'error',
  })
  setTimeout(() =>  router.push('/login') , 500);
}, 300, {maxWait: 1000});

axios.interceptors.request.use(function (config) {
  config.headers['apiv'] = '1.0';
  config.headers['pv'] = '1.0';
  if (config.url.includes('login')){
    return config;
  }
  let user = JSON.parse(localStorage.getItem("user"));
  config.headers['access_token'] = user?.access_token;
  config.timeout = 3500;
  return config;
}, function (error) {
  return Promise.reject(error);
});
axios.interceptors.response.use(function (response) {
  if(response.data.code == -2){
    toLogin()
  }
  return response;
},function (error) {
  return Promise.reject(error);
});
const font = {fontSize: 30,color: 'rgba(0,0,0,0.07)'};
const wm = ref()
onMounted(() => {
  if (wm.value){
    wm.value.$el.querySelector(":not(#container)").classList.add('water-mark')
  }
})
onUnmounted(() => {
  toLogin.cancel();
})
</script>
<style >
*{
  margin: 0;
  padding: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.login-bg{
  background: #efefef;
}
.el-tabs__active-bar{
  visibility: hidden !important;
}
.h-100{
  height: 100%;
}

@media print {
  .water-mark {
    display: none;
  }
}
</style>
<template>
  <el-watermark content="青岛升平电气有限公司" :font="font" ref="wm" >
    <router-view/>
    <el-empty :description="' '" v-if="width < 1000" style="--el-text-color-secondary: 'rgb(200 31 31 / 60%)';position: fixed;height: 100vh; width: 100vw;z-index: 99999;top: 0;left: 0;background-color: rgba(239,239,239,0.6)">
      <span style="color: #a42121;font-size: 18px;letter-spacing: 1px">{{'窗口宽度不能小于1000px，当前宽度为：' + width + 'px'}}</span>
    </el-empty>
  </el-watermark>
</template>